import axios from "axios"
import ENV from "../config/env"

export const CREATE = 'CREATE'
export const GET_ALL_CLUBS = 'GET_ALL_CLUBS'
export const GET_ONE = 'GET_ONE'
export const PHOTO_CLUB = 'PHOTO_CLUB'
export const UPDATE_CLUB = 'UPDATE_CLUB'
export const UPDATE_LICENCE_CLUB = 'UPDATE_LICENCE_CLUB'

const dispatchClub = (type, payload) => ({type: type, payload: payload})
const token = localStorage.getItem('token')

export const photo = (file, id) => dispatch => {
    return axios.post(`${ENV.API}/photo/${id}`, file, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                return false
            } else {
                console.log(res)
                dispatch(dispatchClub(PHOTO_CLUB, res.data))
                return true
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const create = data => dispatch => {
    return axios.post(`${ENV.API}/club`, data, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchClub(CREATE, false))
                return false
            } else {
                console.log(res.data)
                dispatch(dispatchClub(CREATE, res.data))
                return res.data._id
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const getAllClubs = () => dispatch => {
    return axios.get(`${ENV.API}/clubs`, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchClub(GET_ALL_CLUBS, false))
                return false
            } else {
                dispatch(dispatchClub(GET_ALL_CLUBS, res.data))
                return res.data
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const getOne = id => dispatch => {
    return axios.get(`${ENV.API}/club/${id}`,{headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchClub(GET_ONE, false))
                return false
            } else {
                dispatch(dispatchClub(GET_ONE, res.data))
                return res.data
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const update = data => dispatch => {
    const id = data._id
    delete data._id
    delete data.updatedAt
    delete data.createdAt
    delete data.__v
    return axios.post(`${ENV.API}/update-club/${id}`, data, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchClub(UPDATE_CLUB, false))
                return false
            } else {
                dispatch(dispatchClub(UPDATE_CLUB, res.data))
                return true
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const updateLicenceClub = data => dispatch => {
    return axios.post(`${ENV.API}/update-licence-club/${data.id}`, {validite: data.validite}, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchClub(UPDATE_LICENCE_CLUB, false))
                return false
            } else {
                dispatch(dispatchClub(UPDATE_LICENCE_CLUB, res.data))
                return true
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const exportClubs = () => dispatch => {
    return axios.get(`${ENV.API}/export-clubs`, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                return false
            } else return res.data
        })
        .catch(err => {
            console.log(err)
        })
}
